﻿import { apiPromise, htmlPromise } from '../../../../Resources/Scripts/_Shared/fetch'

export const seasonTickets = {
  getSeasonTicketInformation: async (data) => htmlPromise(`${data.PermitPageUrl?.length > 0 ? data.PermitPageUrl : window.location.pathname}/GetSeasonTicketOverlay`, data).catch((err) => err),
}
